import { useMemo } from 'react';

interface BrandingSettings {
  enabled: boolean;
  logo_url?: string;
  primary_color?: string;
}

interface BrandingColors {
  primary: string;
  primaryLight: string;
  primaryDark: string;
  success: string;
  primaryWithOpacity: (opacity: number) => string;
}

export const useReferentBrandingColors = (branding?: BrandingSettings | null): BrandingColors => {
  return useMemo(() => {
    const primaryColor = branding?.primary_color || '#4ECDC4';
    
    // Fonction pour convertir hex en rgba avec opacité
    const hexToRgba = (hex: string, opacity: number) => {
      const r = parseInt(hex.slice(1, 3), 16);
      const g = parseInt(hex.slice(3, 5), 16);
      const b = parseInt(hex.slice(5, 7), 16);
      return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    };
    
    // Fonction pour assombrir une couleur
    const darkenColor = (hex: string, amount: number) => {
      const r = Math.max(0, parseInt(hex.slice(1, 3), 16) - amount);
      const g = Math.max(0, parseInt(hex.slice(3, 5), 16) - amount);
      const b = Math.max(0, parseInt(hex.slice(5, 7), 16) - amount);
      return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
    };
    
    // Fonction pour éclaircir une couleur
    const lightenColor = (hex: string, amount: number) => {
      const r = Math.min(255, parseInt(hex.slice(1, 3), 16) + amount);
      const g = Math.min(255, parseInt(hex.slice(3, 5), 16) + amount);
      const b = Math.min(255, parseInt(hex.slice(5, 7), 16) + amount);
      return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
    };
    
    return {
      primary: primaryColor,
      primaryLight: lightenColor(primaryColor, 30),
      primaryDark: darkenColor(primaryColor, 30),
      success: '#10B981', // Couleur verte pour les états de succès
      primaryWithOpacity: (opacity: number) => hexToRgba(primaryColor, opacity)
    };
  }, [branding?.primary_color]);
};